import { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { generalAsyncSearch } from "../../../lib/fetchApi"
import { formatAsyncSearchOption } from "../../../lib/lawFirmSearchOptions"
import LawFirmSearchOptionLabel from "../LawFirmSearchOptionLabel"
import OutsideClickComponent from "../../fragments/OutsideClickComponent"

import classes from './CustomSelect.module.css'

export default function CustomSelectAsyncSingle({label, identifier, action, path, fixedDrawer, name, reverseDrawer, rtlDrawer, preSelectedValue, preSelectedOptions, required, minWidth}) {
    const containerRef = useRef(null)
    const toFocus = useRef(null)
    const inputRef = useRef(null)

    const userToken = useSelector(state => state.user.token)

    const [coordinates, setCoordinates] = useState({
        top: null,
        left: null,
        width: null
    })

    const [showDrawer, setShowDrawer] = useState(false)
    const [selectedHidden, setSelectedHidden] = useState(false)
    const [inputValue, setInputValue] = useState('')
    const [selectedValue, setSelectedValue] = useState([])
    const [loading, setLoading] = useState(false)
    const [noOptionsFound, setNoOptionsFound] = useState(false)


    const [options, setOptions] = useState(null)

    const typingTimerRef = useRef()
    const doneTypingInterval = 500;  //time in ms, 5 seconds for example
    function changeInputhandler(event) {

        
        setInputValue(event.target.value ? event.target.value : '')
        clearTimeout(typingTimerRef.current); 
        if (event.target.value && event.target.value != '') {            
            typingTimerRef.current = setTimeout(search.bind(this, event.target.value), doneTypingInterval);
        } else {
            setOptions(null)
        }       

   
    }

    async function search(inputValue)  {   
        setLoading(true)
        let values = []
        setNoOptionsFound(false)        

        const searchedData = await generalAsyncSearch(userToken, path, inputValue)
    
        if (searchedData && searchedData.length) {
            searchedData.forEach(element => {
                values.push(formatAsyncSearchOption(element, path))
            });
            
        } else {
            setNoOptionsFound(true)
        }

        if (values && values.length) {
            setOptions(values)
        } else {
            setOptions(null)
        }
        // return values

        setLoading(false)
    }

    function inputBlurHandle() {
        setInputValue('')
    }

    function focusHandler(e) {
        setShowDrawer(true) // show drawer on focus
        setSelectedHidden(true) //if there is a selected value, need to set it hidden

        if (fixedDrawer) {
            if (containerRef && containerRef.current) {
                let left = containerRef.current.getBoundingClientRect().left
                let bottom = containerRef.current.getBoundingClientRect().bottom
                let width = containerRef.current.getBoundingClientRect().width

                setCoordinates({
                    top: bottom + 4,
                    left: left,
                    width: width
                })
            }
        }
        
    }
    function blurHandler() {
        setShowDrawer(false)
        setSelectedHidden(false)
        // setOptions(optionsData) // clear the filters
    }


    
    function setOptionHandler(item) {
        if (item?.value != preSelectedValue) {
            setInputValue('') //clear input
            setShowDrawer(false) //close drawer
            setSelectedHidden(false) //show the selected value  

            setSelectedValue(item) //set value
        
            if (action) {
                action({
                    data: {
                        value: item.value
                    },
                    identifier: identifier,
                    option: item,
                    path: path
                })
            }
        }
        
    }

    function setOptionHandlerEffect(item) {
        setInputValue('') //clear input
        setSelectedValue(item) //set value
        setShowDrawer(false) //close drawer
        setSelectedHidden(false) //show the selected value    
        
    }

    const justToggledClosedByMouseDownRef = useRef(false)

    function focusSelectOnClickHandler() {
        if (justToggledClosedByMouseDownRef.current) {
            justToggledClosedByMouseDownRef.current = false
            return
        }
        if (showDrawer) return
        setShowDrawer(true)
        // setSelectedHidden(true) //if there is a selected value, need to set it hidden
        if (inputRef && inputRef.current) {
            inputRef.current.focus()
        }
    }

    function toggleOnMouseDownHandler(event) {
        if (showDrawer) {
            event.preventDefault()
            justToggledClosedByMouseDownRef.current = true
            blurHandler()
            inputRef.current?.blur()
        }
    }


    useEffect(() => {
        
        if (preSelectedOptions) {
            // setOptionHandlerEffect(preSelectedValue) 
            let values = preSelectedOptions.map(item => {
                return {
                    label: item.name,
                    value: item.law_firm_id,
                    ...item
                }
            })
            setOptions(values) 
            if (preSelectedOptions.length == 1) {
                setOptionHandlerEffect(values[0]) 
            } else {
                setOptionHandlerEffect(null)
            }
        } else {
            setInputValue('') //clear input
            setShowDrawer(false) //close drawer
            setSelectedHidden(false) //show the selected value        
            setSelectedValue(null)
        }
        // if (preSelectedValue) {
        //     setOptionHandlerEffect(preSelectedValue)  
        // } else {
        //     setInputValue('') //clear input
        //     setShowDrawer(false) //close drawer
        //     setSelectedHidden(false) //show the selected value        
        //     setSelectedValue(null)
        // }


        
    }, [preSelectedOptions])


    return <div className={`${classes.container} ${(showDrawer || selectedValue) ? classes.is_focused : ''} ${!label && classes.no_label_container}`} style={{minWidth: minWidth ? minWidth : ''}}>
        <OutsideClickComponent task={blurHandler}>   
            {/* backgroundColor: bkColor,  */}
            <div ref={containerRef} onMouseDown={toggleOnMouseDownHandler} onClick={focusSelectOnClickHandler} className={`${classes.input_container} ${(selectedValue && selectedValue.color) && 'bk_' + selectedValue.color.split(' ').join('_')}  `} >
                {label && <div className={`${classes.label} label`} >{label}</div>}
                
               
                <input ref={inputRef} type='text' onChange={changeInputhandler} onFocus={focusHandler} onBlur={inputBlurHandle} className={classes.input} value={inputValue ? inputValue : ''} autoComplete="off" title={selectedValue?.label} />
                
                 {/* type='hidden' */}
                <input name={name}  defaultValue={selectedValue?.value ? selectedValue?.value : ''} autoComplete="off" required={required} type='hidden' style={{opacity: 0, float: 'left', width:0, height: 1, position: 'absolute'}}/>

                {selectedValue && <div className={classes.selected_shadow} style={{opacity: 0}}>{selectedValue.label}</div>}
                {selectedValue && <div className={`${classes.selected} selected`} style={{opacity: selectedHidden ? 0 : 1}} >{selectedValue.label}</div>}


                <div className={`select_pointer ${classes.pointer} ${showDrawer && classes.opened}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M4.5 6.75L9 11.25L13.5 6.75" stroke="#577988" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                {/* {hasRemove && <button type='button' className={`${classes.clear_select} custom_select_clear_button`} onClick={clearSelectionHandler}><i className='ti ti-x'></i></button>} */}

            </div>
           {showDrawer && <div className={`${classes.drawer} ${reverseDrawer ? classes.reverse_drawer : ''} ${rtlDrawer ? classes.rtl_drawer : ''} ${fixedDrawer ? classes.fixed : ''}`} style={{top: coordinates.top, left: coordinates.left, width: coordinates.width}}>
                {loading && <div className={classes.drawer_loading}>Loading...</div>}
                
                {!loading && <>
                    {noOptionsFound && <div className={classes.drawer_instructions}>No results found</div>}
                    {options && !noOptionsFound && options.filter(item => !item.isDisabled).map(item => (
                        <div key={item.value}>
                            <button type='button' onClick={setOptionHandler.bind(this, item)} className={`${classes.option} ${(selectedValue && (selectedValue.value == item.value)) ? classes.option_selected : ''}`}>
                                {path === 'law-firms'
                                    ? <LawFirmSearchOptionLabel label={item.label} code={item.code} name={item.name} verified={item.verified} />
                                    : item.label}
                            </button>
                        </div>
                    ))}
                    {!options && !noOptionsFound && preSelectedValue && preSelectedValue.length > 0 && preSelectedValue.map(item => (
                        <div key={item.value}>
                            <button type='button' onClick={setOptionHandler.bind(this, item)} className={`${classes.option} ${(selectedValue && (selectedValue.find(val => val.value === item.value))) ? classes.option_selected : ''}`}>{item.label}</button>
                        </div>
                    ))}
                    {!options && !noOptionsFound && !preSelectedValue && <div className={classes.drawer_instructions}>Start typing to search</div>}
                </>}
            </div>}
        </OutsideClickComponent>
    </div>
}